import { Button, Drawer, Timeline } from "antd";
import React, { useCallback, useState, useEffect, useMemo } from "react";
import styles from "./index.module.less";
import Bus from "@/utils/bus";
import RecordCleanModal from "./RecordCleanModal";
import { usePrevious } from "@/utils/chat/index";
import { getGroupCleanRecord } from "@/api/egroup";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import { UserState } from "@/models/user";
import Empty from "@/components/Supervise/components/empty";
import InfiniteScroll from "react-infinite-scroller";
import { Avatar } from "@/baseComponents/Avatar";
import { Jlmate, ymdDate } from "@/utils/date";
import Context from "@/components/chat/context";
import { isGroupAdmin, isGroupOwner } from "@/utils/chat/group";
import IconFont from "@/components/icon";
import { tagsNode } from "@/components/AddressBook/common";

function GroupRecordClean(props: any) {
  const { groupRosterIdentity } = React.useContext(Context);
  const { selectedSession } = props;
  const [wrapVisible, setWrapVisible] = useState(false);
  const [cleanModalVisible, setCleanModalVisible] = useState(false);
  const preWrapVisible = usePrevious(wrapVisible);
  const [cleanRecord, setCleanRecord] = useState<any>([]);
  const [pageNum, setPageNum] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const pageSize = 20;

  const handleWrapShow = useCallback(() => {
    setWrapVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setWrapVisible(false);
  }, []);

  useEffect(() => {
    Bus.on("recordClean:open", handleWrapShow);
    return () => {
      Bus.off("recordClean:open", handleWrapShow);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRecordList = useCallback(() => {
    setLoading(true);
    getGroupCleanRecord({
      groupId: selectedSession?.sessionId,
      pageNo: pageNum,
      pageSize
    })
      .then((res) => {
        if (res?.list?.length) {
          setCleanRecord([...cleanRecord, ...res.list.filter(i => !!i.gmtCreate)]);
          setPageNum(res?.pageNo + 1);
          setHasMore(res?.pageCount > res?.pageNo);
        } else {
          setHasMore(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession.sessionId, pageNum, cleanRecord]);

  const isAdmin = useMemo(() => {
    return isGroupAdmin(groupRosterIdentity) || isGroupOwner(groupRosterIdentity);
  }, [groupRosterIdentity]);

  const cleanRecordList = useMemo(() => {
    return cleanRecord.length > 0 ? (
      <div className={styles["record-list"]}>
        <InfiniteScroll
          pageStart={1}
          initialLoad={false}
          loadMore={getRecordList}
          hasMore={hasMore}
          useWindow={false}
        >
          <Timeline className={styles["time-line-container"]}>
            {cleanRecord.map((item: any, index: number) => (
              <Timeline.Item key={`clean-record-${index}`}>
                <div className={styles["list-container"]} key={index}>
                  <div className={styles["list-head"]}>{Jlmate(item.gmtCreate)}</div>
                  <div className={`${styles["list-body"]} ${!isAdmin ? styles["inline"] : ""}`}>
                    {isAdmin && (
                      <div className={styles["list-body-avatar"]}>
                        <Avatar src={item.avatar} name={item.name} />
                      </div>
                    )}
                    <div className={styles["list-body-desc"]}>
                      {isAdmin && (
                        <div className={styles["list-body-info"]}>
                          <div className={styles["info-name"]}>{item.name}</div>
                          {tagsNode(item.labelInfoList)}
                          <div className={styles["info-unit"]}>
                            {item.unitName ? `@${item.unitName}` : null}
                          </div>
                        </div>
                      )}
                      <div className={styles["tip"]}>
                        {`${isAdmin ? "" : "群管理员"} 擦除${
                          item.cleanAll === 1 ? "" : `${ymdDate(item.beginTime)}-`
                        }${ymdDate(item.endTime)}${item.cleanAll === 1 ? "之前" : ""}的消息记录`}
                      </div>
                    </div>
                  </div>
                </div>
              </Timeline.Item>
            ))}
          </Timeline>
        </InfiniteScroll>
      </div>
    ) : null;
  }, [cleanRecord, getRecordList, hasMore, isAdmin]);

  const clearData = useCallback(() => {
    setCleanRecord([]);
    setPageNum(1);
    setHasMore(true);
  }, []);

  useEffect(() => {
    if (wrapVisible && !preWrapVisible) {
      getRecordList();
    } else if (!wrapVisible && preWrapVisible){
      clearData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wrapVisible, preWrapVisible, getRecordList]);

  const handleOpen = useCallback(() => {
    setCleanModalVisible(true);
  }, []);

  const DrawerTitle = useMemo(() => {
    return (
      <div className={styles["drawer-title"]}>
        <IconFont type="iconwin_left" className={`${styles["icon"]} app-region-none`} onClick={handleClose} />
        <span className="management-title">消息擦除记录</span>
      </div>
    );
  }, [handleClose]);

  // footer
  const DrawerFooter = useMemo(() => {
    if (isAdmin) {
      return (
        <Button className={styles["drawer-footer-btn"]} onClick={handleOpen}>
          擦除消息记录
        </Button>
      );
    } else {
      return null;
    }
  }, [isAdmin, handleOpen]);

  return (
    <>
      <Drawer
        title={DrawerTitle}
        className={styles["record-clean-wrap"]}
        placement="right"
        width="310px"
        onClose={handleClose}
        visible={wrapVisible}
        destroyOnClose={false}
        maskClosable={true}
        footer={DrawerFooter}
        zIndex={99}
      >
        {!loading && !cleanRecord.length ? <Empty text="暂无记录" /> : cleanRecordList}
      </Drawer>
      <RecordCleanModal
        modalVisible={cleanModalVisible}
        handleClickClose={() => setCleanModalVisible(false)}
      />
    </>
  );
}

function mapStateToProps({ chat, user }: { chat: ChatState, user: UserState }) {
  return {
    selectedSession: chat.selectedSession,
    userData: user.userData
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupRecordClean);
